module.exports = __webpack_public_path__ + "4a2bc254bd191bdf8eb9cecbc2896cef.svg";